export default __webpack_public_path__ + "static/media/Search-User.263b25fe.svg";